import type { EntryDescriptor, EntryField } from './ClinicalEventEntry';
const text = (key: string, label: string): EntryField => ({ key, label });
export const postpartumCourseGroups: Record<string, EntryDescriptor[]> = {
  'Maternal review': [
    {
      eventType: 'PP.COURSE_ASSESSMENT',
      label: 'Maternal postpartum review',
      subjectTypes: ['MOTHER'],
      fields: [
        text('lochia_color', 'Lochia color'),
        text('lochia_amount', 'Lochia amount'),
        text('lochia_odor', 'Lochia odor'),
        text('perineum_healing', 'Perineal healing'),
        text('incision_healing', 'Incision healing'),
        text('breasts', 'Breasts'),
        text('nipples', 'Nipples'),
        text('bladder', 'Bladder'),
        text('bowel', 'Bowel'),
        { key: 'pain_score', label: 'Pain score (0–10)', kind: 'number' },
        text('mood', 'Mood'),
        text('contraception_plan', 'Contraception plan'),
        { key: 'notes', label: 'Maternal notes', kind: 'textarea' },
      ],
    },
  ],
  'Maternal vitals': [
    { eventType: 'VITALS.BP', label: 'Blood pressure', subjectTypes: ['MOTHER'] },
    { eventType: 'VITALS.PULSE', label: 'Pulse', subjectTypes: ['MOTHER'] },
    { eventType: 'VITALS.TEMP', label: 'Temperature', subjectTypes: ['MOTHER'] },
    { eventType: 'PP.FUNDUS', label: 'Fundus', subjectTypes: ['MOTHER'] },
  ],
  'Newborn review': [
    {
      eventType: 'NB.COURSE_ASSESSMENT',
      label: 'Newborn postpartum review',
      subjectTypes: ['NEWBORN'],
      fields: [
        { key: 'feeding_frequency_per24h', label: 'Feedings per 24 hours', kind: 'number' },
        text('latch', 'Latch'),
        { key: 'voids_per24h', label: 'Voids per 24 hours', kind: 'number' },
        { key: 'stools_per24h', label: 'Stools per 24 hours', kind: 'number' },
        text('jaundice_visual_zone', 'Observed jaundice distribution'),
        { key: 'tcb_value', label: 'Transcutaneous bilirubin value', kind: 'number' },
        {
          key: 'tcb_unit',
          label: 'Transcutaneous bilirubin unit',
          options: [
            { value: 'mg/dL', label: 'mg/dL' },
            { value: 'umol/L', label: 'µmol/L' },
          ],
        },
        text('cord', 'Cord assessment'),
        text('metabolic_screen_status', 'Metabolic screen status'),
        text('cchd_status', 'CCHD screen status'),
        text('hearing_status', 'Hearing screen status'),
        { key: 'exam_findings', label: 'Examination findings', kind: 'textarea' },
        { key: 'notes', label: 'Newborn notes', kind: 'textarea' },
      ],
    },
  ],
  'Newborn vitals / feeding': [
    { eventType: 'NB.MEASUREMENTS', label: 'Measurements', subjectTypes: ['NEWBORN'] },
    { eventType: 'VITALS.TEMP', label: 'Temperature', subjectTypes: ['NEWBORN'] },
    { eventType: 'VITALS.PULSE', label: 'Heart rate', subjectTypes: ['NEWBORN'] },
    { eventType: 'VITALS.RR', label: 'Respiratory rate', subjectTypes: ['NEWBORN'] },
    { eventType: 'NB.FEEDING', label: 'Feeding', subjectTypes: ['NEWBORN'] },
    { eventType: 'NB.SCREEN', label: 'Screening status', subjectTypes: ['NEWBORN'] },
  ],
};
